export default __webpack_public_path__ + "static/media/menu-offers-white.b838b2a8.svg";